export default __webpack_public_path__ + "static/media/04AW1NOV65.8fc2e987.jpg";